import { useStore } from '@nanostores/react';
import type { UIEvent } from 'react';
import { DialogHeader, DialogActions, DialogButton } from '~/components/ui/Dialog';
import { supabaseStore } from '~/lib/stores/supabase';
import { userStore } from '~/lib/stores/user';

interface DeleteChatDialogContentProps {
  itemDescription?: string;
  onDeleteItem?: (event: UIEvent) => void;
  onClose?: (event: UIEvent) => void;
}

export const DeleteChatDialogContent = ({ itemDescription, onDeleteItem, onClose }: DeleteChatDialogContentProps) => {
  const featureFlags = useStore(userStore.featureFlags);
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);

  const showDatabaseWarning = featureFlags.supabaseManagement && supabaseStatus === 'CONFIGURED';

  const dialogDescription = (
    <>
      <p>
        You are about to delete <strong>{itemDescription}</strong>.
      </p>
      <p className="mt-1">
        Are you sure you want to delete this chat?
        {showDatabaseWarning && <span> This will also delete your database. This action is irreversible.</span>}
      </p>
    </>
  );

  return (
    <>
      <DialogHeader title="Delete Chat?" description={dialogDescription} />

      <DialogActions>
        <DialogButton variant="secondary" onClick={onClose}>
          Cancel
        </DialogButton>
        <DialogButton color="danger" onClick={onDeleteItem}>
          Delete
        </DialogButton>
      </DialogActions>
    </>
  );
};
